export const GET_ACHIEVEMENTS_REQUEST = 'AchievementPage/GET_ME_REQUEST';
export const GET_ACHIEVEMENTS_SUCCESS = 'AchievementPage/GET_ME_SUCCESS';
export const GET_ACHIEVEMENTS_FAILURE = 'AchievementPage/GET_ME_FAILURE';
